<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật : {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="code" label="Mã" class="form-item">
                  <el-input v-model="modelData.code" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="priority" label="Vị trí ưu tiên" class="form-item">
              <el-input v-model="modelData.priority" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Khoa'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        level_id: '',
        name: '',
        code: '',
        status: true
      },
      configData: {
        level: {
          id: 0,
          name: 'Tên khóa này'
        },
        facult: {
          id: 0,
          name: 'Tên khóa này'
        }
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listLevel: []
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên chuyên ngành' }
        ]
      }
    }
  },
  mounted () {
    this.configDataAndBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    configDataAndBreadcrumb () {
      this.modelData.level_id = this.$route.params.level_id
      this.modelData.facult_id = this.$route.params.facult_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('levels/' + this.$route.params.level_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.level = response.data
            this.fetchFacult()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      axios.get('facults/' + this.$route.params.facult_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.facult = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'levels-index', text: 'Hệ đào tạo' },
        { name: 'levels-show', text: this.configData.level.name, level_id: this.$route.params.level_id },
        { name: 'facults-show', text: this.configData.facult.name, level_id: this.$route.params.level_id, facult_id: this.$route.params.facult_id },
        { name: 'specializeds-create', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'facults-show', params: {level_id: this.$route.params.level_id, facult_id: this.$route.params.facult_id}})
      // this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
      // this.$router.push({name: 'specializeds-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('specializeds/' + this.$route.params.specialized_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchListCategoryCourse () {
      axios.get('levels', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.put('specializeds/' + this.$route.params.specialized_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.$router.push({name: 'facults-show', params: {level_id: this.$route.params.level_id, facult_id: this.$route.params.facult_id}})
            // this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
            // this.$router.push({name: 'specializeds-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/specializeds/Update.vue